// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart2_first__3Cv1h","second":"Chart2_second__ZEh5Y","third":"Chart2_third__gt_zs","four":"Chart2_four__3GTEE","five":"Chart2_five__1dACb","six":"Chart2_six__3H2Ga"};